const dataGroupsListAdapter = data => {
   if (!data) return [];

   return data.map(ele => ({ id: ele.id, name: ele.name }))
};

export default dataGroupsListAdapter;
